export default __webpack_public_path__ + "static/media/526.2346eb96.png";